/**
 * Flip state for shell rail / secondary tiles.
 * Sidebar remounts on every route change (App layout helpers), so in-component
 * useState alone loses the open face — this module keeps the last flip keys.
 */
export const shellFlipStore = {
  railKey: null,
  secondaryKey: null,
};
